import { WorkspacePanelTypeEnumType } from '@mark43/cad-api';
import { useContext } from 'react';
import { assertNonNull } from '../../queues/utils/assert-non-null';
import { WorkspacePanel } from '../workspace-panel';
import { WorkspacePanelContext } from '../workspace-panel-provider';

export function useWorkspacePanel<T extends WorkspacePanelTypeEnumType | unknown = unknown>(
    isFirstResponder = false
): WorkspacePanel<T> {
    const workspacePanel = useContext(WorkspacePanelContext);

    // temporary solution for now, because we don't have a context - the fr-app is not wrapped in the WorkspacePanelProvider
    if (isFirstResponder) {
        return {} as WorkspacePanel;
    }

    assertNonNull(workspacePanel, 'Unexpectedly did not find WorkspacePanel');
    return workspacePanel as WorkspacePanel<T>;
}
